export const SAVE_ALL_ADDITIONAL_INFORMATIONS =
  'SAVE_ALL_ADDITIONAL_INFORMATIONS'
export const SAVE_ADDITIONAL_INFORMATION = 'SAVE_ADDITIONAL_INFORMATION'
